/*
 * Functions to check status of an esim and then decorate the status box
 */

/*
 * @param {object} infoBox - The status box HTML element
 * @param {bool} esimInstalled - Whether the esim is installed or not
 * @param {bool} activeBundle - Whether the esim has an active bundle or not
 * @param {bool} queuedBundle - Whether the esim has a queued bundle or not
 * */
function checkEsimStatusStyleInfoBox(infoBox, esimInstalled, activeBundle, queuedBundle) {

	// Check if activeBundle and !esimInstalled
	if (activeBundle) {
		// Code for activeBundle and esimInstalled case
        let title = window.esimDetailsStrings.esimNotInstalled;
        let text = window.esimDetailsStrings.installOnADevice;

        infoBox.querySelector("#esim-status-title").innerText = title;
        infoBox.querySelector("#esim-status-text").innerText = text;
	}

	// Check if queuedBundle and esimInstalled
	if (queuedBundle && esimInstalled) {
		// Code for queuedBundle and esimInstalled case
        let title = window.esimDetailsStrings.bundleQueued;
        let text = window.esimDetailsStrings.queuedBundleSuffix;

        infoBox.querySelector("#esim-status-title").innerText = title;
        infoBox.querySelector("#esim-status-text").innerText = text;
	}

	// Check if queuedBundle and !esimInstalled
	if (queuedBundle && !esimInstalled) {
		// Code for queuedBundle and not esimInstalled case
        let title = window.esimDetailsStrings.esimNotInstalled;
        let text = window.esimDetailsStrings.installOnADevice;

        infoBox.querySelector("#esim-status-title").innerText = title;
        infoBox.querySelector("#esim-status-text").innerText = text;
	}

	// Check if esimInstalled
	if (esimInstalled) {
		// Code for esimInstalled case
        let title = "";
        let text = window.esimDetailsStrings.noPlanAssigned;

        infoBox.querySelector("#esim-status-title").innerText = title;
        infoBox.querySelector("#esim-status-text").innerText = text;
	}

	// Check if !esimInstalled
	if (!esimInstalled) {
		// Code for not esimInstalled case
        let title = window.esimDetailsStrings.esimNotInstalled;
        let text = window.esimDetailsStrings.installOnADevice;

        infoBox.querySelector("#esim-status-title").innerText = title;
        infoBox.querySelector("#esim-status-text").innerText = text;
	}
}
